module.exports = __webpack_public_path__ + "static/media/2.04cc69c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/trolls-girl/trinket/2.png
// module id = 96
// module chunks = 0